<template>
  <div class="box_bookmarks">
    
    <div class="nav_bookmarks">
      <router-link to="/books" title="点击进入我的书籍页面" class="nav_grey">已阅读书籍</router-link>
      <span class="nav_hover">我的书签</span>
    </div>
    <div class="book_name" v-if="book_info">{{book_info.book_name}}({{book_info.volume_name}})</div>
    <div class="time_line" v-if="bookmarks" ref="scrollList">
      <div
        :class="[index%2==0?'right':'left','list']"
        v-for="(item,index) in bookmarks"
        :key="index"
      >
        <span class="img_circle" @click="marksgo(item)">
          <img :src="item.url" alt />
        </span>
        <span class="text">
          <span class="page" @click="marksgo(item)">
            第
            <span class="font_74">{{item.page}}</span>页
          </span>
          <span class="time" @click="marksgo(item)">{{item.add_time}}</span>
        </span>
      </div>
    </div>
    <div v-if="is_all" class="no_more">没有更多了</div>
    <!-- <div v-else class="more_info">
            <div v-if="isLoading">
                <img src="../../assets/public/ancientBooks/loading.gif" alt="加载">
            </div>
    </div>-->
  </div>
</template>
<script>
import {addstamp} from '../../util/stamp';
export default {
  data() {
    return {
      current_page: 1,
      per_page: 10,
      bookmarks: [],
      book_info: null,
      is_all: false,
      isLoading: false,
      isKaiGuan: true,
      volume_id: null,
      book_total_count:null
    };
  },
  created() {
    this.user_id = parseInt(this.$store.state.user_id);
    this.volume_id = this.$route.query.volume_id;
    const hashLocation = this.$route.path;
    //   const newLocation = hashLocation.split("#/")[1];
    const url = "https://www.kanguji.com" + hashLocation;
    this.$matomo.setCustomUrl(url); //覆盖页面报告的url，可以自定义页面url，加上本页面路由
    //   this.$matomo.trackEvent(shopCode,hashLocation);//事件
    // this.$matomo.trackPageView(hashLocation);//页面名称,可以自定义页面名称
  },
  mounted() {
    this.getBookmarks();
    if (this.$route.path == "/bookMarks") {
      window.addEventListener("scroll", this.menu);
    } else {
      window.addEventListener("scroll", "");
    }
  },
  methods: {
    getBookmarks() {
      this.loading = true;
      let datas = {
        user_id: this.user_id,
        volume_id: this.volume_id,
        page: this.current_page++,
        page_size: this.per_page
      };
      var sign = addstamp(datas)
      delete datas.token
      datas['sign'] = sign
      this.$axios
        .get("/marks", {
          params: datas
        })
        .then(res => {
          // console.log(res)
          this.total_pages = res.data.data.total_pages;
          this.current_page = res.data.data.current_page;
          this.book_total_count = res.data.data.book_total_count;

          if (res.data.status_code == 200) {
            this.isLoading = false;
            this.isKaiGuan = true;
            if (this.current_page == this.total_pages) {
              this.is_all = true;
              this.isKaiGuan = false;
            }
            if (this.current_page === 1) {
              this.bookmarks = res.data.data.book_marks;
            } else {
              this.bookmarks = this.bookmarks.concat(res.data.data.book_marks);
            }
            this.book_info = res.data.data.book_info;
          }
        });
    },
    marksgo(item) {
      // console.log(item)
      let pictureUrl = this.$router.resolve({
        path: "/picture",
        query: {
          volume_id: this.volume_id,
          imd: item.img_id,
          ct: this.book_total_count
        }
      });
      // console.log(pictureUrl)
      window.open(pictureUrl.href, "_blank");
    }
  }
};
</script>
<style lang="scss" scoped="" type="text/css">
.box_bookmarks {
  width: 1200px;
  margin: 40px auto 0;
  // background-color:#fff;
  .nav_grey {
    color: #666;
    font-size: 14px;
    font-family: PingFangSC-Regular, sans-serif;
    display: inline-block;
  }
  .nav_hover {
    font-size: 14px;
    font-family: PingFangSC-Regular, sans-serif;
    background: url("../../assets/public/companyNews/next_icon@2x.png")
      no-repeat left center;
    background-size: 16px;
    padding-left: 20px;
    line-height: 20px;
    color: #333;
  }
  .book_name {
    font-size: 24px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #333;
    text-align: center;
    line-height: 1;
    margin-top: 10px;
  }
  .time_line {
    // padding: 2em 0;
    position: relative;
    margin-top: 15px;
    margin-bottom: 60px;
    padding-top: 50px;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 50%;
      height: 100%;
      width: 2px;
      background: #dcdcdc;
      margin-left: -1px;
    }
    .list {
      width: 610px;
      box-sizing: border-box;
      position: relative;
      margin-bottom: 98px;
      // margin-top:50px;
      &:last-child {
        margin-bottom: 35px;
      }
      &::before {
        display: block;
        content: "";
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background-color: #e5e5e5;
        position: absolute;
      }
      &::after {
        display: block;
        content: "";
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #d55d3a;
        position: absolute;
      }
      .img_circle {
        display: inline-block;
        width: 86px;
        height: 86px;
        border: 7px solid #eeeeee;
        border-radius: 50%;
        overflow: hidden;
        vertical-align: top;
        cursor: pointer;
        img {
          margin-left: -40px;
          margin-top: -30px;
        }
      }
      .text {
        vertical-align: top;
        // margin-left:20px;
        margin: 0px 20px;
        margin-top: -22px;
        .page,
        .time {
          display: block;
        }
        .page {
          color: #da7453;
          font-size: 28px;
          cursor: pointer;
          .font_74 {
            font-size: 74px;
            font-family: DINAlternate-Bold;
            margin-right: 5px;
          }
        }
        .time {
          display: block;
          font-size: 34px;
          font-family: DINAlternate-Bold;
          color: #5a4f4c;
          cursor: pointer;
        }
      }
    }
    .right {
      float: right;
      padding-left: 30px;
      &::before {
        top: 40px;
        left: 2px;
      }
      &::after {
        top: 43px;
        left: 5px;
      }
      .img_circle,
      .text {
        float: left;
        text-align: left;
      }
    }
    .left {
      padding-right: 30px;
      float: left;
      &::before {
        top: 40px;
        right: 2px;
      }
      &::after {
        top: 43px;
        right: 5px;
      }
      .img_circle,
      .text {
        float: right;
        text-align: right;
      }
    }

    &::after {
      content: "";
      display: table;
      clear: both;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/page/bookMarks.vue